import { classes } from "../../../../../../../../shared/react/react"
import { DropDown } from "./Dropdown"
import { Option, readWriteOptions } from "./options"

export interface Props {
    setPermissions(permissions: {}): void
}


export function GroupCell({ setPermissions }: Props) {

    const options = readWriteOptions

    const select = (option: Option) => setPermissions(option.values)

    return <div className={classes("dropdown-cell")}>

        <DropDown
            buttonIcon="fa-solid fa-ellipsis"
            options={options.options}
            select={select}
            isSelected={_ => false}
            includeSelectedIcon={false}
            disabled={false}
        />

    </div>

}
